module.exports = __webpack_public_path__ + "static/img/android@2x.390e7e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/new_home/android@2x.png
// module id = 450
// module chunks = 0